
import ResourceList from './resource-list.vue';
import ResListHandler from './res-list-handler.vue';

export default {
  components: {
    ResourceList: ResourceList,
    ResListHandler: ResListHandler
  },

  props: {
    languages: {
      type: Array,
      required: true
    },

    category: {
      type: Object,
      default: null
    },

    page: {
      type: String,
      required: true
    }
  },

  methods: {
    getResourceList: function getResourceList(language) {
      return Array.isArray(language.preview_urls) ? language.preview_urls.map(function (item) {
        return { file_url: item };
      }) : [];
    },
    isUpdatable: function isUpdatable(language) {
      if (this.page === 'custom') {
        return true;
      }
      return language && language.is_basic !== 1;
    },
    handleChange: function handleChange(_ref) {
      var resource = _ref.resource,
          index = _ref.index,
          language = _ref.language;

      this.$emit('change', { resource: resource, index: index, language: language });
    }
  }
};